import useUser from 'components/GenericsHooks/useUser';
import React from 'react';

export const withIntegrity = (WrappedComponent: any) => (props: any) => {
  let {initialValues, columnOptions, ...ignoredProps} = props;
  const user = useUser();
  const integrityColumnOptions = [
    {
      column: 'revision',
      allowEdit: false,
      hiddenAdd: true,
      hiddenEdit: true,
    },
    {
      column: 'updateDate',
      allowEdit: false,
      allowAdd: false,
      hiddenAdd: true,
      hiddenEdit: true,
    },
    {
      column: 'updatedBy',
      allowEdit: false,
      allowAdd: false,
      hiddenAdd: true,
      hiddenEdit: true,
    },
    {
      column: 'deleted',
      hiddenAdd: true,
      hiddenEdit: true,
    },
  ];

  //Merge or replace integrity column options
  if (Array.isArray(columnOptions)) {
    columnOptions = [...integrityColumnOptions, ...columnOptions];
  } else {
    columnOptions = integrityColumnOptions;
  }

  var today = new Date();
  let totalDate = today.toISOString();
  const integrityInitialValues = {
    updateDate: totalDate,
    updatedBy: user,
    reason: '',
  };

  //Merge or replace integrity initial values
  initialValues = initialValues || {};
  initialValues = {...integrityInitialValues, ...initialValues};

  const wrapperProps = {initialValues, columnOptions, ...ignoredProps};
  return <WrappedComponent {...wrapperProps} />;
};
